import React from "react";
import { Field } from "redux-form";
import { FormRow, Select } from "MODULES/shared/components/Forms";
import { Col } from "react-bootstrap";
import { CANCELLATION_REASONS } from "MODULES/SalesOrders/constants";

export default function CancellationReason() {
  return (
    <div>
      <FormRow>
        <Col md={6}>
          <Field
            name="cancellation_reason"
            className="text-right"
            component={Select}
            options={CANCELLATION_REASONS}
            prompt={false}
            label="Cancellation Reason"
          />{" "}
        </Col>
      </FormRow>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/CancellationReason.jsx